import React from 'react';
import './Resume.css';

const Resume = () => {
  return (
    <div className="resume-container">
      <h1>Resume</h1>
      <div className="resume-content">
        <iframe
          src={`${process.env.PUBLIC_URL}/resume.pdf`}
          width="100%"
          height="800px"  // Adjust the height as needed
          title="Resume"
        ></iframe>
      </div>
    </div>
  );
};

export default Resume;
